module.exports = __webpack_public_path__ + "static/media/KU_logo.d86a25ef.svg";